import { useCallback } from "react";
import { Handle, Position, NodeProps } from "react-flow-renderer";

function CustomDefaultNode({ data }: NodeProps) {
   const dataArray = data.label.split("\\n");

   return (
      <>
         <Handle type="target" position={Position.Top} />
         {dataArray.map((ele: string, index: any) => (
            <div key={index}>{ele}</div>
         ))}
         <Handle type="source" position={Position.Bottom} />
      </>
   );
}

export default CustomDefaultNode;
